import { DefaultTheme } from 'styled-components'
import { darkMode, theme } from 'styles/theme'
import { ukDarkMode, ukTheme } from 'styles/uk'

const getThemeByLanguage = (lang: string): DefaultTheme => {
    // TODO: legacy code for changing font size within app, probably to remove in the future
    // const globalFontSize = cookieStorage.getItem('fontSize')
    // if (globalFontSize === 'normal') return { ...theme }
    // if (globalFontSize === 'bigger') return { ...theme, ...biggerFontSize }
    // if (globalFontSize === 'big') return { ...theme, ...bigFontSize }

    if (lang === 'uk') return ukTheme
    return theme
}

const getDarkModeByLanguage = (lang: string): DefaultTheme => {
    if (lang === 'uk') return ukDarkMode
    return darkMode
}

export { getThemeByLanguage, getDarkModeByLanguage }
